import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=14ea0eae&scoped=true&"
import script from "./message-item.vue?vue&type=script&lang=js&"
export * from "./message-item.vue?vue&type=script&lang=js&"
import style0 from "./message-item.vue?vue&type=style&index=0&id=14ea0eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea0eae",
  null
  
)

export default component.exports